import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "use", "usageTracker", "usageTrackerAppLocationKey", "featureId", "featureCategoryId", "onClick", "eventName", "eventProperties"];
import { AIBaseButton } from './internal/AIBaseButton';
import { BREEZE_SPECIAL } from '../../constants/BreezeUse';
import { useTracker } from '../../hooks/useTracker';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const CopilotDropdownButton = _ref => {
  let {
      children = /*#__PURE__*/_jsx(_Fragment, {}),
      use = 'tertiary',
      // default to tertiary,
      usageTracker,
      usageTrackerAppLocationKey,
      featureId,
      featureCategoryId,
      onClick,
      eventName,
      eventProperties
    } = _ref,
    uiButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    aiTracker
  } = useTracker(usageTracker, usageTrackerAppLocationKey);
  const useOverride = use === BREEZE_SPECIAL ? undefined : use;
  const handleClick = event => {
    if (onClick) {
      onClick(event);
      if (aiTracker) {
        aiTracker.track('aiButtonInteraction', {
          type: 'dropdown - trigger',
          featureId,
          featureCategoryId
        });
        // Custom tracking
        if (eventName && eventProperties) {
          aiTracker.track(eventName, eventProperties);
        }
      }
    }
  };
  return /*#__PURE__*/_jsx(AIBaseButton, Object.assign({}, uiButtonProps, {
    onClick: handleClick,
    use: useOverride,
    children: children
  }));
};
export default CopilotDropdownButton;